import { useRef } from "react";
import { cn } from "@/lib/utils";

/**
 * MagneticButton — wraps any clickable element and translates it slightly
 * toward the cursor on hover. Disabled on touch devices and when
 * `prefers-reduced-motion: reduce` is set.
 */
export const MagneticButton = ({
    as: Component = "button",
    className = "",
    strength = 14,
    children,
    ...rest
}) => {
    const ref = useRef(null);

    const onMove = (e) => {
        if (typeof window !== "undefined" &&
            (window.matchMedia("(pointer: coarse)").matches ||
             window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
            return;
        }
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const x = e.clientX - (r.left + r.width / 2);
        const y = e.clientY - (r.top + r.height / 2);
        el.style.setProperty("--mgx", `${(x / r.width) * strength}px`);
        el.style.setProperty("--mgy", `${(y / r.height) * strength}px`);
    };

    const onLeave = () => {
        const el = ref.current;
        if (!el) return;
        el.style.setProperty("--mgx", "0px");
        el.style.setProperty("--mgy", "0px");
    };

    return (
        <Component
            ref={ref}
            onMouseMove={onMove}
            onMouseLeave={onLeave}
            className={cn("pg-magnetic", className)}
            {...rest}
        >
            {children}
        </Component>
    );
};

export default MagneticButton;
